var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Button, { ButtonProps } from "./Button/Button";
import React from 'react';
import { mq, styled } from "../utils";
var StickyContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  button {\n    opacity: 0.96;\n    border-radius: 0;\n  }\n\n  ", "\n"], ["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  button {\n    opacity: 0.96;\n    border-radius: 0;\n  }\n\n  ",
    "\n"])), mq({
    display: ['block', 'block', 'none'],
}));
var MobileStickyButton = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React.createElement(StickyContainer, { "data-component": "MobileStickyButton", className: className },
        React.createElement(Button, __assign({ block: true }, props), children)));
};
export default MobileStickyButton;
var templateObject_1;
//# sourceMappingURL=MobileStickyButton.js.map